import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=1d2e24f8"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"
import style0 from "./UserPage.vue?vue&type=style&index=0&id=1d2e24f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports